<div class="page-section">

    <p class="page-heading">Support Page</p>

    <p class="page-description-heading">Support Team Hours of Operation</p>
    <p class="page-description">
      Our support team is available to assist you during the following hours:
      </p>
      <ul>
        <li>
            <span class="day">Monday to Friday : </span>
            <span class="time">9:00 AM to 6:00 PM (EST)</span>
        </li>
        <li>
            <span class="day">Saturday : </span>
            <span class="time">10:00 AM to 4:00 PM (EST)</span>
        </li>
        <li>
            <span class="day">Sunday : </span>
            <span class="time">Closed</span>
        </li>
    </ul>

    <p class="page-description-heading">First Response SLA</p>
    <p class="page-description">
      We aim to respond to all support inquiries within 24 hours during our hours of operation. Inquiries received outside of these hours will be addressed on the next business day.</p>


    <p class="page-description-heading">Support Options</p>
    <p class="page-description-sub-heading">1. Create a Support Case</p>
    <p class="page-description">
      If you need assistance, you can create a support case through our support portal. Please provide detailed information about your issue to help us resolve it efficiently. Create a Support Case using the <a href="https://wealthgrowth.cognerium.com/feedback" target="_blank" class="page-link-text">Support Form</a></p>
    <p class="page-description-sub-heading">2. Email Support</p>
    <p class="page-description">
      For support inquiries, you can email us at: <a href="mailto:contact@cognerium.com" target="_blank" class="page-link-text">contact@cognerium.com</a></p>



  <p class="page-description page-content-bold">
    For any additional support needs or inquiries outside the provided channels, please contact us at: <a href="mailto:contact@cognerium.com" target="_blank" class="page-link-text">contact@cognerium.com</a>
  </p>

</div>
